import { FC, InputHTMLAttributes } from 'react'

import { SingleDatePicker } from '@joor/design-system'
import { useField } from 'formik'

import { BaseProps } from './Field'

export type PropsType = BaseProps &
  Omit<InputHTMLAttributes<HTMLInputElement>, 'name'>

const Datepicker: FC<PropsType> = ({ required, ...props }) => {
  const [
    { onBlur: _fieldOnBlur, value, ...field },
    meta,
    { setValue, setTouched },
  ] = useField({
    disabled: props.disabled,
    name: props.name,
  })
  const shouldShowError = meta.touched && !!meta.error
  return (
    <SingleDatePicker
      id={props.name}
      onDateChange={(newDate) => {
        setValue(newDate)
      }}
      onFocusChange={() => {
        setTouched(true)
      }}
      focused={false}
      isRequired={required}
      date={value}
      {...(shouldShowError && { errorMessage: meta.error })}
      {...field}
      {...props}
    />
  )
}

export default Datepicker
